import {defineStore} from 'pinia'
import {useApiRequestStore} from '../../ApiRequestStore/useApiRequestStore'
import {OperatingSystemType} from '@toolify/server/src/controllers/NativeAppController/enum/OperatingSystemType'
import {IOperatingSystemTypeInterfacesMap} from '@toolify/server/src/services/OperatingSystemService/types/IOperatingSystemTypeInterfacesMap'
import {IUpdateOperatingSystemDataRequestInterfaces} from '@toolify/server/src/controllers/CurrentSessionController/validators/UpdateOperatingSystemData/types/IUpdateOperatingSystemDataRequestInterfaces'

export const useCurrentSessionApiStore = defineStore('currentSessionApi', {
  actions: {
    async updateOperatingSystemData<T extends OperatingSystemType = OperatingSystemType>(
      data: IOperatingSystemTypeInterfacesMap[T]['payload'],
    ): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.put<IUpdateOperatingSystemDataRequestInterfaces>(
        '/me/current-session/operating-system-data',
        {
          data: {
            operatingSystemData: data,
          },
        },
      )
    },
  },
})
